import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import {
  TableContainer,
  Table,
  TableRow,
  TableCell,
  TableBody,
  Tooltip,
  IconButton,
} from "@material-ui/core";
import { withRouter } from "react-router";

import DeleteIcon from "@material-ui/icons/Delete";

import CustomTableHead from "../../../Component/Table/CustomTableHead/CustomTableHead";
import { useStyles } from "./Cart.css";

class CartTable extends Component {
  render() {
    const { classes } = this.props;
    return (
      <TableContainer>
        <Table>
          <CustomTableHead column={this.props.column} />
          <TableBody>
            {this.props.cart.map((data, index) => (
              <TableRow key={index}>
                <TableCell align="center">{index + 1}</TableCell>
                <TableCell align="center">
                  {data.id.bookCoverUrl === "undefined" ||
                  !data.id.bookCoverUrl ? (
                    "Not Available"
                  ) : (
                    <img
                      src={data.id.bookCoverUrl}
                      alt={data.id.title}
                      style={{ width: 80, height: 80 }}
                    />
                  )}
                </TableCell>
                <TableCell
                  align="center"
                  className={classes.tableCell}
                  onClick={() =>
                    this.props.history.push(`/books/details/${data.id._id}`)
                  }
                >
                  {data.id.title}
                </TableCell>
                <TableCell align="center">{data.id.genre}</TableCell>
                <TableCell align="center">1</TableCell>
                <TableCell align="center">{data.id.price}</TableCell>
                <TableCell align="center">
                  <Tooltip
                    arrow
                    title="delete"
                    onClick={() => this.props.deleteFromCart(data.id._id)}
                  >
                    <IconButton
                      disableRipple
                      style={{ backgroundColor: "#fff" }}
                    >
                      <DeleteIcon style={{ color: "#0a1f3a" }} />
                    </IconButton>
                  </Tooltip>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    );
  }
}

export default withStyles(useStyles)(withRouter(CartTable));
